import { usePageContext } from '@/components/page-context/context'

export function usePageTabCounts() {
	const context = usePageContext()
	if (!context) {
		throw new Error('usePageTabCounts must be used within a PageProvider')
	}
	return {
		tabCounts: context.tabCounts || {},
		setTabCounts: context.setTabCounts,
	}
}
